module.exports = __webpack_public_path__ + "static/media/whatsapp.00359c31.svg";